<template lang="pug">
v-menu(
  ref="menu",
  v-model="datePicker",
  :close-on-content-click="true",
  :nudge-right="10"
)
  template(v-slot:activator="{ on }")
    v-text-field(
      :label="label"
      outline
      v-model="date"
      readonly
      v-on="on"
      @click="() => datePicker = true")
  v-date-picker(
    v-model="date"
    :max="max || ''"
    locale="es"
    @input="closeDatePicker"
    no-title)
</template>
<script>
export default{
  props: ['label', 'max'],
  data () {
    return {
      date: '',
      datePicker: false
    }
  },
  methods: {
    closeDatePicker () {
      this.$emit('changeDate', this.date)
      this.datePicker = false
    }
  }
}
</script>

<style>
  .v-date-picker-table .v-btn.v-btn--active {
    color: #0855c4;
  }
  .v-input.select-box.v-text-field .v-input__control .v-input__slot .v-menu .v-menu__content.theme--light.menuable__content__active {
    top: 0px !important;
    left: 0px !important;
  }

  .v-text-field.v-text-field--enclosed {
    margin-left: 2.5px;
    margin-right: 2.5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DatePicker.vue